import { defineStore } from 'pinia';
import { useAnalyticsStore } from "@nextories/vue-core-components/src/store/analyticsStore";

export const useActionsStore = defineStore('actions', {
  state: () => ({
    isPasswordModalDisplayed: false,
  }),

  actions: {
    displayPasswordModal() {
      this.isPasswordModalDisplayed = true;
    },

    hidePasswordModal() {
      this.isPasswordModalDisplayed = false;
    },

    track(label: string) {
      const analyticsStore = useAnalyticsStore();
      analyticsStore.track({
        category: import.meta.env.nxt.analytics.category,
        action: import.meta.env.nxt.analytics.action?.[label],
        label: import.meta.env.nxt.analytics.label?.[label],
      });
    },
  },
});
